import {Findings} from '@github-ui/copilot-findings'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {SplitPageLayout} from '@primer/react'
import {Suspense} from 'react'
import {useLayoutQuery} from '../page-data/loaders/use-layout-query'
import {usePullRequestBasePath} from '../stores/layout-selectors'
import styles from './Findings.module.css'

export const FindingsEntrypoint = () => (
  <ErrorBoundary boundaryName="FindingsEntrypoint" fallback={null}>
    <Suspense fallback={null}>
      <FindingsContent />
    </Suspense>
  </ErrorBoundary>
)

const FindingsContent = () => {
  const basePath = usePullRequestBasePath()
  const {
    data: {aliveChannels},
  } = useLayoutQuery()

  return (
    <div id="findings-content" className="width-full" role="region" tabIndex={-1} aria-label="Findings">
      <SplitPageLayout className={styles.wrapper}>
        <Findings pullRequestBasePath={basePath} aliveChannel={aliveChannels.pullRequest} />
      </SplitPageLayout>
    </div>
  )
}
